<mat-tab-group class="bg-white">
  <mat-tab label="Emergency Evacuation Plan">

    <div class="app-margin">

      <div class="container-fluid">
        <div class="row">
          <div class="col">

            <h6 *ngIf="site.emergency_phone || site.hospital_address || site.hospital_phone || site.medical_centre_address || site.medical_centre_phone">Emergency Numbers & Locations</h6>

            <ng-container *ngIf="site.emergency_phone">
              <b>Emergency Phone</b>
              <p id="emergency_phone">{{ site.emergency_phone }}</p>
            </ng-container>

            <ng-container *ngIf="site.hospital_address">
              <b>Hospital Address</b>
              <p id="hospital_address">{{ site.hospital_address }}</p>
            </ng-container>

            <ng-container *ngIf="site.hospital_phone">
              <b>Hospital Phone</b>
              <p id="hospital_phone">{{ site.hospital_phone }}</p>
            </ng-container>

            <ng-container *ngIf="site.medical_centre_address">
              <b>Medical Centre Address</b>
              <p id="medical_centre_address">{{ site.medical_centre_address }}</p>
            </ng-container>

            <ng-container *ngIf="site.medical_centre_phone">
              <b>Medical Centre Phone</b>
              <p id="medical_centre_phone">{{ site.medical_centre_phone }}</p>
            </ng-container>

            <h6 *ngIf="site.first_aid_kit_location || site.aed_location || site.fire_extinguisher_location">First Aid Kit, AED & Fire Extinguisher</h6>

            <ng-container *ngIf="site.first_aid_kit_location">
              <b>First Aid Kit Location</b>
              <p id="first_aid_kit_location">{{ site.first_aid_kit_location }}</p>
            </ng-container>

            <ng-container *ngIf="site.aed_location">
              <b>AED (Automated External Defibrillator) Location</b>
              <p id="aed_location">{{ site.aed_location }}</p>
            </ng-container>

            <ng-container *ngIf="site.fire_extinguisher_location">
              <b>Fire Extinguisher Location</b>
              <p id="fire-extinguisher-location">{{ site.fire_extinguisher_location }}</p>
            </ng-container>

          </div>

          <div class="col">

            <h6 *ngIf="site.alarm_description || site.assembly_location">Evacuation Alerts & Assembly Locations</h6>

            <ng-container *ngIf="site.alarm_description">
              <b>Description of Alarm</b>
              <p id="alarm_description">{{ site.alarm_description }}</p>
            </ng-container>

            <ng-container *ngIf="site.assembly_location">
              <b>Assembly Location</b>
              <p id="assembly_location">{{ site.assembly_location }}</p>
            </ng-container>

            <h6 *ngIf="site.worksafe_phone || site.civil_defence_phone || site.poison_centre_phone || site.power_phone || site.faults_phone">Additional Contact Numbers</h6>

            <ng-container *ngIf="site.worksafe_phone">
              <b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.worksafe-phone', 'WorkSafe Phone') }}</b>
              <p id="worksafe_phone">{{ site.worksafe_phone }}</p>
            </ng-container>

            <ng-container *ngIf="site.civil_defence_phone">
              <b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.civil-defence-phone', 'Civil Defence Phone') }}</b>
              <p id="civil_defence_phone">{{ site.civil_defence_phone }}</p>
            </ng-container>

            <ng-container *ngIf="site.poison_centre_phone">
              <b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.poison-centre-phone', 'Poison Centre Phone') }}</b>
              <p id="poison_centre_phone">{{ site.poison_centre_phone }}</p>
            </ng-container>

            <ng-container *ngIf="site.power_phone">
              <b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.power-phone', 'Power (Customer Service) Phone') }}</b>
              <p id="power_phone">{{ site.power_phone }}</p>
            </ng-container>

            <ng-container *ngIf="site.faults_phone">
              <b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.faults-phone', '24Hr Faults Phone') }}</b>
              <p id="faults_phone">{{ site.faults_phone }}</p>
            </ng-container>

          </div>
        </div>

        <div class="row" appMarginBottom>
          <div class="col">
            <small><b>Note:</b> Fields that are left empty will not show to users.</small>
          </div>
        </div>
      </div>

    </div>

  </mat-tab>

  <mat-tab label="Safety Managers">
    <app-sites-eep-safety-managers [site_id]="site.id"></app-sites-eep-safety-managers>
  </mat-tab>

  <mat-tab label="First Aiders">
    <app-sites-eep-first-aiders [site_id]="site.id"></app-sites-eep-first-aiders>
  </mat-tab>

  <mat-tab label="Emergency Evacuation Plan Map">

    @if(site.evacuation_map_url) {
      @if(utils.isImage(site.evacuation_map_url)) {
        <div class="p-3">
          <h4>Uploaded Image</h4>
          <img (click)="onDownloadEmergencyEvacuationPlanMap(site)" style="cursor: pointer;" [src]="site.evacuation_map_url" class="profile-picture" alt="Emergency Evacuation Plan Map" />
          <p><small>Click to download.</small></p>
        </div>
      } @else {
        <mat-nav-list dense>
          <h6 matSubheader>Uploaded PDF</h6>
          <mat-list-item>
            <span matListItemTitle>Emergency Response Plan Map</span>

            <button
              matListItemMeta
              mat-icon-button
              ngxClipboard
              aria-label="Copy file URL"
              matTooltip="Copy this file URL."
              [cbContent]="site.evacuation_map_url"
              (click)="onCopiedURL()"
              class="dialog-button my-auto ml-2 mr-0"
              style="cursor: pointer;">
              <mat-icon>content_copy</mat-icon>
            </button>

            <button
              matListItemMeta
              mat-icon-button
              aria-label="Download file"
              matTooltip="Download this file."
              (click)="onDownloadEmergencyEvacuationPlanMap(site)"
              class="dialog-button my-auto ml-2 mr-0"
              style="cursor: pointer;">
              <mat-icon>download</mat-icon>
            </button>

            <button
              matListItemMeta
              mat-icon-button
              aria-label="Preview file"
              matTooltip="View this file."
              (click)="onOpenUrl(site.evacuation_map_url)"
              class="dialog-button my-auto ml-2 mr-0"
              style="cursor: pointer;">
              <mat-icon>preview</mat-icon>
            </button>
          </mat-list-item>
        </mat-nav-list>
      }
    } @else {
      <p>No emergency evacuation plan map has been uploaded yet.</p>
    }
  </mat-tab>
</mat-tab-group>


